import { render, staticRenderFns } from "./FilterDisplay.vue?vue&type=template&id=0827b8c0"
import script from "./FilterDisplay.vue?vue&type=script&lang=js"
export * from "./FilterDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports